var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { newEntity, showImportPanel } from "../actions/uploadsActions";
import { t } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";
import { Icon } from "../../UI";

export class UploadsHeader extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "content-header" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: () => this.props.newEntity('uploads') }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "plus" }), " ", t('System', 'New entity')), /*#__PURE__*/

      _jsx("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: this.props.showImportPanel }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "upload" }), " ", t('System', 'Import')))));




  }
}






function mapDispatchToProps(dispatch) {
  return bindActionCreators({ newEntity, showImportPanel }, wrapDispatch(dispatch, 'uploads'));
}

export default connect(null, mapDispatchToProps)(UploadsHeader);